import { css, styled } from 'canoe';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  // Allow toolbox to scroll a bit further to allow for the (potential) intercom button (see ../../Toolbox.tsx)
  height: calc(100% + 70px);
`;

export const PlacementsTabCTAWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    background: ${theme.colors.OnyxGrayD20};
    border-top: 1px solid ${theme.colors.AquaTeal};
    margin-top: ${theme.spaces.xs};
  `}
`;
export const PlacementsTabCTA = styled.div`
  ${({ theme }) => css`
    height: 53px;
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spaces.s} ${theme.spaces.xs};

    &:not(:first-child) {
      border-left: 1px solid ${theme.colors.Contrast};
    }
  `}
`;
